export default "__VITE_ASSET__BYamGBCV__"